var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSanPham(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    rx: 12.5,
    fill: "#205EFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6925 10.8697H15.4269M9.57275 10.8697L9.96337 11.2604L11.1352 10.0885M12.6925 14.5156H15.4269M9.57275 14.5156L9.96337 14.9062L11.1352 13.7343M10.9373 17.7083H14.0623C16.6665 17.7083 17.7081 16.6666 17.7081 14.0624V10.9374C17.7081 8.33329 16.6665 7.29163 14.0623 7.29163H10.9373C8.33317 7.29163 7.2915 8.33329 7.2915 10.9374V14.0624C7.2915 16.6666 8.33317 17.7083 10.9373 17.7083Z",
    stroke: "white",
    strokeWidth: 0.695652,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSanPham);
export default __webpack_public_path__ + "static/media/icon_san_pham.d900cb519349af3bbc485b8aab1400fd.svg";
export { ForwardRef as ReactComponent };